var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup26973(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.04742 6.25251C5.59563 6.25251 6.8507 5.06019 6.8507 3.58939C6.8507 2.11859 5.59563 0.92627 4.04742 0.92627C2.49921 0.92627 1.24414 2.11859 1.24414 3.58939C1.24414 5.06019 2.49921 6.25251 4.04742 6.25251Z",
    fill: "#475785"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1326 10.1302C16.1326 11.5987 14.9079 12.7933 13.4025 12.7933H7.16211C8.66759 12.7933 9.89226 11.5987 9.89226 10.1302C9.89226 9.3997 9.58804 8.73012 9.08882 8.25076C8.59739 7.76379 7.91095 7.46704 7.16211 7.46704H13.4025C14.9079 7.46704 16.1326 8.66164 16.1326 10.1302Z",
    fill: "#475785"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M10.6525 7.46704V12.7933H2.86797C2.08133 12.7933 1.36024 12.4965 0.844004 12.0096C0.319574 11.5302 0 10.8606 0 10.1302C0 8.66164 1.28649 7.46704 2.86797 7.46704H10.6525Z",
    fill: "#475785"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.147 6.25251C13.6952 6.25251 14.9503 5.06019 14.9503 3.58939C14.9503 2.11859 13.6952 0.92627 12.147 0.92627C10.5988 0.92627 9.34375 2.11859 9.34375 3.58939C9.34375 5.06019 10.5988 6.25251 12.147 6.25251Z",
    fill: "#475785"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26973);
export default __webpack_public_path__ + "static/media/Group 26973.8378a9632b35e982d0d7152ceed2465c.svg";
export { ForwardRef as ReactComponent };